import React from "react";
import PropTypes from "prop-types";

import { Image } from "@sparefoot/react-commons";
import { MapPinOutline } from "components/core/Icons";
import { Text, Paragraph, H4 } from "components/core/Typography";

import "./TestimonialCard.scss";

const TestimonialCard = ({ title, body, author, location, imageSrc }) => (
	<div className="brand-testimonial-card">
		<div className="card-image">
			<Image
				src={imageSrc}
				alt={author}
				lazy
				width="152"
				height="152"
			/>
		</div>
		<div className="card-body">
			<div className="card-header">
				<H4>{title}</H4>
				<div>
					<Text className="author-text">{`by ${author}`}</Text>|
					<Text className="location-text">
						<MapPinOutline fill="lightGray" />
						{location}
					</Text>
				</div>
			</div>
			<Paragraph
				size="small"
				className="quote-text"
			>{`${body}\u201D`}</Paragraph>
		</div>
	</div>
);

TestimonialCard.propTypes = {
	body: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	author: PropTypes.string.isRequired,
	location: PropTypes.string.isRequired,
	imageSrc: PropTypes.string.isRequired
};

export default TestimonialCard;
